import { UbicacionDTO } from "@/application/dto/ubicaciones/UbicacionDTO";
import { IHttpClient } from "@/application/ports/IHttpClient";
import { Ubicacion } from "@/domain/entities/ubicacion";
import { API_ENDPOINTS } from "../config/api.config";
import { IUbicacionRepository } from "@/domain/repositories/IUbicacionRepository";
import { UbicacionParamsDTO } from "@/application/dto/ubicaciones/UbicacionParamsDTO";

export class UbicacionRepository
    implements IUbicacionRepository {

    constructor(
        private readonly httpClient: IHttpClient
    ) { }

    async findAll(params?: UbicacionParamsDTO): Promise<Ubicacion[]> {
        const response = await this.httpClient.get<UbicacionDTO[]>(
            API_ENDPOINTS.ubicacion.base,
            { params }
        );

        return response.data.map((dto) => this.mapToEntity(dto));
    }

    async findById(
        id: string
    ): Promise<Ubicacion> {
        const response = await this.httpClient.get<UbicacionDTO>(
            API_ENDPOINTS.ubicacion.byId(id)
        );

        return this.mapToEntity(response.data);
    }
    async create(
        data: Omit<Ubicacion, 'id'>
    ): Promise<Ubicacion> {
        const response = await this.httpClient.post<UbicacionDTO>(
            API_ENDPOINTS.ubicacion.base,
            data
        );

        return this.mapToEntity(response.data);
    }
    async update(
        id: string,
        data: Omit<Ubicacion, 'id'>
    ): Promise<Ubicacion> {
        const response = await this.httpClient.put<UbicacionDTO>(
            API_ENDPOINTS.ubicacion.byId(id),
            data
        );

        return this.mapToEntity(response.data);
    }
    private mapToEntity(
        dto: UbicacionDTO
    ): Ubicacion {

        return {
            id: dto.id,
            nombre: dto.nombre,
            grupo: dto.grupo,
            usuario: dto.usuario,
            fecha: dto.fecha,
            direccion: dto.direccion,
            barrio: dto.barrio,
            provincia: dto.provincia,
            cp: dto.cp,
            observaciones: dto.observaciones,
            grupo_id: dto.grupo_id
        };
    }
}
